import React, {useEffect, useRef, useState} from 'react'
import {GridItem, Grid, Text, Image, Flex, Box} from '@chakra-ui/react'
import {InviteModal} from "../../Theme";
import {ReactComponent as Eye} from "../../../assets/EyeIconProducts.svg";
import ExistingModal from "../../Theme/ExistingModal";

const AccessoryViewModal = ({isOpenAccessoryView, onCloseAccessoryView, luminaire, viewType, type}) => {
    const [accessory, setAccessory] = useState()
    const [orderShow, setOrderShow] = useState(false)
    const [colorShow, setColorShow] = useState(false)
    const [certifShow, setCertifShow] = useState(false)
    const colorRef = useRef(null)
    const certifRef = useRef(null)
    const orderRef = useRef(null)

    useEffect(() => {
        if (viewType === 'existing'){
            if (type === 'power'){
                setAccessory(luminaire?.powerSupplyExisting)
            } else if (type === 'control'){
                setAccessory(luminaire?.controlExisting)
            }else if (type === 'accessories'){
                setAccessory(luminaire?.accessoryExisting)
            }
        } else if (viewType === 'recommended'){
            if (type === 'power'){
                if (luminaire?.recomendedPowerSupply?.length > 0){
                    setAccessory(JSON.parse(luminaire?.recomendedPowerSupply))
                }
            } else if (type === 'control'){
                const controlData = luminaire?.controlRecomendedAirtable || luminaire?.recomendedControl
                if (controlData) {
                    setAccessory(JSON.parse(controlData))
                } else {
                    setAccessory('')
                }
            }
            else if (type === 'accessories'){
                setAccessory(JSON.parse(luminaire?.accessoryRecomendedAirtable))
            }
        }

    },[isOpenAccessoryView])

    return (
        <ExistingModal
            minW='1168px'
            bg='#193C5B'
            headerColor='white'
            isOpen={isOpenAccessoryView}
            onClose={onCloseAccessoryView}
            title='Product Details'
            py={0}
            type={type}
        >
            {
                accessory && (
                    <>
                        {
                            viewType !== 'existing' ?
                                <Flex
                                    pl={3}
                                    mt={5}>
                                    <Flex borderRadius='5px' alignItems='center' justifyContent='center' height='123px' width='145px' border='2px solid #DBDADA'>
                                        {accessory['Product Image (hyperlink)'] && (
                                            <Image
                                                border='none'
                                                height='100%'
                                                width='100%'
                                                src={accessory['Product Image (hyperlink)'] ? accessory['Product Image (hyperlink)'] : ''}/>
                                        )}
                                    </Flex>
                                    <Grid ml={5} templateColumns='repeat(2,1fr)' width='full' gap={3}>
                                        <GridItem colSpan='2' fontSize='24px'>
                                            <b>{accessory['FE Product Description']}</b>
                                        </GridItem>
                                        <GridItem colSpan='1' fontSize='18px'>
                                            <Flex><b>Supplier: </b>&nbsp;Focus Earth</Flex>
                                        </GridItem>
                                        <GridItem colSpan='1' fontSize='18px'>
                                            <Flex>
                                                <b>Product Type: </b>&nbsp;
                                                {type
                                                    ? type === "power"
                                                        ? "Power Supply"
                                                        : type.charAt(0).toUpperCase() + type.slice(1)
                                                    : type}
                                            </Flex>
                                        </GridItem>
                                        <GridItem colSpan='1' fontSize='18px'>
                                            <Flex><b>Manufacturer: </b>&nbsp;{accessory['Manufacturer']}</Flex>
                                        </GridItem>
                                        <GridItem colSpan='1' fontSize='18px' position='relative'>
                                            <Text display='flex' alignItems='center'  ref={orderRef}>
                                                Order Code:&nbsp; <Eye className='eye_icon' onClick={() => setOrderShow(true)}/>&nbsp;
                                                <Box as='span' position='relative'>{accessory['Order Code']?.toString()?.replace(/(.{15})..+/, "$1…")}
                                                    {/*<Box display={orderShow ? 'block' : 'none'} position='absolute' top='0'>{led['Order Code']?.toString()}</Box>*/}
                                                </Box>
                                            </Text>
                                        </GridItem>
                                    </Grid>
                                </Flex>
                                : ''
                        }
                        <Grid fontSize='12px' pb={5} pl={3} mt={5} columnGap={5} templateColumns='repeat(3, 1fr)'>
                            <GridItem p={viewType === 'existing' ? '33px' : 5} borderRadius='10px' border='1px solid #C4C4C4'>
                                <Flex gap={viewType === 'existing' ? '35px' : 3} flexDirection='column'>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Dimensions - Length  (in):</Text>
                                        <Text width='35%' fontWeight='600'>{type === 'accessories' ? luminaire['accessoryLengthA'] : accessory['Length (inches)']}</Text>
                                    </Flex>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Dimensions - Width (in):</Text>
                                        <Text width='35%' fontWeight='600'>{type === 'accessories' ? luminaire['accessoryWidthA'] : accessory['Width (inches)']}</Text>
                                    </Flex>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Dimensions - Diameter (in):</Text>
                                        <Text width='35%' fontWeight='600'>{type === 'accessories' ? luminaire['accessoryDiameterA'] : accessory['Diameter (inches)']}</Text>
                                    </Flex>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Dimensions - Depth (in):</Text>
                                        <Text width='35%' fontWeight='600'>{type === 'accessories' ? luminaire['accessoryDepthA'] : accessory['Depth (inches)']}</Text>
                                    </Flex>
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Voltage (min):</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Voltage (min)']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType !== 'existing' ?
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Compatible Product Order Codes:</Text>
                                                <Text width='35%' fontWeight='600' style={{display: 'flex',flexWrap: "wrap"}}>{accessory['Compatible Product Order Codes']}</Text>
                                            </Flex>
                                            : ''
                                    }
                                </Flex>
                            </GridItem>
                            <GridItem p={viewType === 'existing' ? '33px' : 5} borderRadius='10px' border='1px solid #C4C4C4'>
                                <Flex gap={viewType === 'existing' ? '35px' : 3} flexDirection='column'>
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Voltage (max):</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Voltage (max)']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Dimmability:</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Dimmability']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Type:</Text>
                                        <Text width='35%' fontWeight='600'>{viewType === "existing" && type === "accessories" ? luminaire['accessoryTypeA'] : accessory['Type']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                    </Flex>
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Warranty (years):</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Warranty (years)']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Certifications:</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Certifications']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Buy America:</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Buy America']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Manufacturer</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        type === 'control'
                                                            ? luminaire['controlManufacturer']
                                                            : type === 'power'
                                                                ? luminaire['powerSupplyManufacturer']
                                                                : type === 'accessories'
                                                                    ? luminaire['accessoryManufacturerA']
                                                                    : luminaire['accessoryManufacturerA']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'power' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Dimming</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        accessory['Dimming']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'power' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Model:</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        luminaire['powerSupplyModel']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'control' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Added Wattage:</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                      luminaire['controlExisting']['wattage']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'control' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Model:</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        luminaire['controlModel']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'control' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Product Code:</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        luminaire['controlRecomendedProductCode']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'accessories' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Color:</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        luminaire['accessoryColorA']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' && type === 'accessories' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Product Code:</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {
                                                        luminaire['accessoryProductCodeA']
                                                    }
                                                </Text>
                                            </Flex>
                                        ) : ''
                                    }
                                </Flex>
                            </GridItem>
                            <GridItem p={viewType === 'existing' ? '33px' : 5} borderRadius='10px' border='1px solid #C4C4C4'>
                                <Flex gap={viewType === 'existing' ? '35px' : 3} flexDirection='column'>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Price Per Unit ($):</Text>
                                        <Text width='35%' fontWeight='600'>
                                            {viewType === 'existing' ? (
                                                '$' + Number(accessory['PPU ($)']).toFixed(2)
                                            ) : viewType === 'recommended' && type === 'accessories' ? (
                                                '$' + Number(luminaire['accessoryExisting']['PPU ($)']).toFixed(2)
                                            ) :  (
                                                '$' + Number(accessory['Price Per Unit ($)']).toFixed(2)
                                            )}
                                        </Text>
                                    </Flex>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Lifetime (hours):</Text>
                                        <Text width='35%' fontWeight='600'>
                                            {viewType === 'existing' ? (
                                                accessory['Lifetime (hrs)']
                                            ) : (
                                                (Number(
                                                    String(accessory?.['Lifetime (hours)']).replace(/[^0-9.]/g, '')) || 0)
                                                    .toLocaleString('en-US', { maximumFractionDigits: 0 })
                                            )}
                                        </Text>
                                    </Flex>
                                    <Flex justifyContent='space-between'>
                                        <Text width='65%' fontWeight={viewType === 'existing' ? 700 : 400} color='#A9A9A9'>Installation (minutes):</Text>
                                        <Text width='35%' fontWeight='600'>
                                            {
                                                viewType === 'existing' && type === 'control'
                                                    ? luminaire['controlExisting']['Installation Time (min)']
                                                    : viewType === 'existing' && type === 'power'
                                                        ? luminaire['powerSupplyExisting']['Installation Time (min)']
                                                        : viewType === 'existing' && type === 'accessories'
                                                            ? luminaire['accessoryExisting']['Installation Time (min)']
                                                            : accessory['Approx. Installation Time (minutes)']
                                            }
                                        </Text>
                                    </Flex>
                                    {
                                        viewType !== 'existing' ? (
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Delivery (days):</Text>
                                                <Text width='35%' fontWeight='600'>{Number(accessory['Approx. Delivery (days)'])}</Text>
                                            </Flex>
                                        ) : ''
                                    }
                                    {
                                        viewType === 'existing' ?
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' fontWeight={700} color='#A9A9A9'>Recycling Cost ($):</Text>
                                                <Text width='35%' fontWeight='600'>
                                                    {type === 'power' ? (
                                                        '$' +  Number(luminaire['powerSupplyExisting']['Recycling Cost ($)']).toFixed(2)
                                                    ) : type === 'control' ? (
                                                         '$' + Number(luminaire['controlExisting']['Recycling Cost ($)']).toFixed(2)
                                                        )
                                                        :  '$' + Number(accessory['Recycling Cost ($)']).toFixed(2)
                                                    }
                                                </Text>
                                            </Flex>
                                            : ''
                                    }
                                    {
                                        viewType !== 'existing' ?
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Vol. Tier 1 (min qty):</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Volume Tier 1 (min qty)']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                            : ""
                                    }
                                    {
                                        viewType !== 'existing' ?
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Vol. Tier 1 PPU ($)</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Volume Tier 1 PPU ($)']}</Text>
                                            </Flex>
                                            : ""
                                    }
                                    {
                                        viewType !== 'existing' ?
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Vol. Tier 2 (min qty):</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Volume Tier 2 (min qty)']?.toString()?.replace(/(.{12})..+/, "$1…")}</Text>
                                            </Flex>
                                            : ""
                                    }
                                    {
                                        viewType !== 'existing' ?
                                            <Flex justifyContent='space-between'>
                                                <Text width='65%' color='#A9A9A9'>Vol. Tier 2 PPU ($):</Text>
                                                <Text width='35%' fontWeight='600'>{accessory['Volume Tier 2 PPU ($)']}</Text>
                                            </Flex>
                                            : ""
                                    }
                                </Flex>
                            </GridItem>
                        </Grid>

                    </>
                )
            }
        </ExistingModal>
    )
}

export default AccessoryViewModal